// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"355":"ad04e0cca0cc0cbf","462":"e3dc6e87e4494ea6"}[chunkId] + ".js";
};